<template>
	<section class="section post">
		<div class="container">
			<div class="post__heading">
				<h3 class="post__title">Recent Posts</h3>
				<!--<router-link-->
					<!--:to="{-->
						<!--name: 'create-forum-post'-->
					<!--}"-->
					<!--class="post__link">-->
					<!--Create new post-->
				<!--</router-link>-->
			</div>
			<div class="post__wrapper">
				<Flickity v-if="Object.keys(forumTopics).length > 0" ref="flickity" :options="options">
					<div
						v-for="topic in forumTopics"
						:key="topic.key"
						class="post__item">
						<div class="post__left">
							<img v-if="topic.user.avatar" class="post__img" :src="topic.user.avatar" alt="">
							<img v-else class="post__img" src="../../assets/img/profile.jpg" alt="">
						</div>
						<div class="post__right">
							<router-link
								@click.native="setForumPost(topic)"
								:to="{
									name: 'forum-thread',
									params: {id: topic.id}
								}"
								class="post__main">
								{{ topic.title }}
							</router-link>
							<h6 class="post__sub">
								{{`${topic.user.fname} ${topic.user.lname}` }}</h6>
							<div class="post__meta">
								<span>{{ topic.created_at | time}}</span>
							</div>
						</div>
					</div>
				</Flickity>
			</div>
			<div class="carousel__controls">
				<button class="control right" @click="next">
					<svg width="10" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.86 7L.92 2.03a.67.67 0 0 1-.25-.52c0-.2.09-.38.25-.51l.52-.44a.95.95 0 0 1 .62-.21c.23 0 .45.07.61.2L9.75 6.5c.16.14.25.32.25.52s-.09.38-.25.51l-7.07 5.94a.95.95 0 0 1-.62.2.95.95 0 0 1-.61-.2l-.52-.44a.65.65 0 0 1 0-1.03L6.86 7z" fill="#009B41"/>
					</svg>
				</button>
				<button class="control left" @click="previous">
					<svg width="10" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.14 7l5.94-4.98a.67.67 0 0 0 .25-.52c0-.2-.09-.38-.25-.51L8.56.55a.95.95 0 0 0-.62-.21.95.95 0 0 0-.61.2L.25 6.5A.67.67 0 0 0 0 7c0 .2.09.38.25.51l7.07 5.94c.17.13.38.2.62.2.23 0 .45-.07.61-.2l.52-.44a.65.65 0 0 0 0-1.03L3.14 7z" fill="#009B41"/>
					</svg>
				</button>
			</div>
		</div>
	</section>
</template>

<script>
import Flickity from 'vue-flickity';
import { mapMutations } from 'vuex';

export default {
	name: 'ForumSlider',
	data() {
		return {
			options: {
				initialIndex: 4,
				pageDots: false,
				prevNextButtons: false,
				wrapAround: true,
				adaptiveHeight: true
			}
		};
	},
	components: {
		Flickity
	},
	props: {
		forumTopics: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	filters: {
		time(value) {
			return moment(value).fromNow();
		}
	},
	methods: {
		...mapMutations([
			'saveForumPost'
		]),
		next() {
			this.$refs.flickity.next();
		},
		previous() {
			this.$refs.flickity.previous();
		},
		setForumPost(forumPost) {
			this.saveForumPost(forumPost);
		}
	}
};
</script>

<style lang="scss" scoped>
	.post__main {
		max-height: 50px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.post__wrapper {
		display: block;
		min-height: 150px;
	}
	.post__item {
		min-width: 26%;
		min-height: 130px;
		&:last-child {
			margin-right: 20px;
		}
	}
	.post .control {
		top: 50%;
		&.right {
			right: 50px!important;
			@media #{$mobile} {
				right: 0!important;
			}
		}
		&.left {
			left: 50px;
		}
	}
</style>
